import parseJSONSGracefully from './parseJSONSGracefully';

// We're using our getter because js-cookie's get() implementation performs some encoding internally.
// Get is only only guaranteed to be fully compatible with cookies set with js-cookie.
// This is an issue because our cookies are set on the server.
// https://github.com/js-cookie/js-cookie#encoding
export const getCookie = (key) => {
    if (!key) {
        return null;
    }

    const docCookie = document.cookie.replace(
        new RegExp(
            `(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(
                /[-.+*]/g,
                '\\$&',
            )}\\s*\\=\\s*([^;]*).*$)|^.*$`,
        ),
        '$1',
    );

    const decodedCookieJson = parseJSONSGracefully(docCookie, docCookie.replace(/\+/g, ' '));
    const decodedCookie = decodeURIComponent(decodedCookieJson);
    return decodedCookie || null;
};

// check if we have a cookie
export function hasCookie(key) {
    if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
        return false;
    }

    return new RegExp(
        `(?:^|;\\s*)${encodeURIComponent(key).replace(/[-.+*]/g, '\\$&')}\\s*\\=`,
    ).test(document.cookie);
}

export function removeCookie(key, domain = window.location.hostname, path = '/') {
    if (!hasCookie(key)) {
        return false;
    }

    // Create a new Date object in the past.
    const expires = new Date(0);

    // delete cookie from current domain
    document.cookie = `${encodeURIComponent(key)}=; expires=${expires.toUTCString()}; path=/`;
    return true;
}
